const config = {
    plexURL: String(process.env.REACT_APP_CLIENT_API_BASE_URL),
    clientURL: String(process.env.REACT_APP_CLIENT_API_BASE_URL),
    wToken: String(process.env.REACT_APP_WTOKEN)
}

export default config;